import React, { useState, useEffect } from 'react';
import axios from 'axios';
import NotificationWithButtons from '../../NotificationWithButtons';
import { ASSETS } from '../../../../utils/config';
import { Modal } from '@mui/material';
import { ScrollableContainer, ModalContent, ModalContainer } from '../NotificationUnlock/NotificationUnlocked.styled';
import { ModalHeader } from '../../../NewAIBuilder/NewAIBuilder.styled';
import CloseIcon from '@mui/icons-material/Close';
import TextView from '../../../TextView';
import FavoriteIcon from '@mui/icons-material/Favorite';
const hardcodedNotifications = [
  { id: 1, name: 'Hijab Fatima', image: ASSETS.Wheely },
  { id: 2, name: 'John Doe', image: ASSETS.Wheely },
  { id: 3, name: 'Jane Smith', image: ASSETS.Wheely },
  { id: 4, name: 'Ali Khan', image: ASSETS.Wheely },
  { id: 5, name: 'Hijab Fatima', image: ASSETS.Wheely },
  { id: 6, name: 'John Doe', image: ASSETS.Wheely },
  { id: 7, name: 'Jane Smith', image: ASSETS.Wheely },
  { id: 8, name: 'Ali Khan', image: ASSETS.Wheely }
];

function Index({onClose}) {
  const [notifications, setNotifications] = useState(hardcodedNotifications);

  useEffect(() => {
    /*
    axios.get('/api/notifications')
      .then(response => {
        setNotifications(response.data);
      })
      .catch(error => {
        console.error("Error fetching notifications:", error);
      });
    */
  }, []);

  return (
    <Modal open={true}>
      <ModalContainer>
        <ModalHeader style={{ marginBottom: '20px' }}>
          <TextView variant="largeTitle">
          <FavoriteIcon
              style={{
                color: 'red', 
                height: '25px',
                width: '25px',
                marginRight: '10px'
              }}
            />
            Favorited By
          </TextView>
          <CloseIcon className="close-icon" onClick={onClose}/>
        </ModalHeader>

        <ScrollableContainer>
          {notifications.map((notification) => (
            <NotificationWithButtons
              key={notification.id}
              name={notification.name}
              image={notification.image}
              leftButtonText="Follow"
              rightButtonText="Message"
            />
          ))}
        </ScrollableContainer>
      </ModalContainer>
    </Modal>
  );
}

export default Index;
